import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import StoreProductTable from './StoreProductTable';
import VendorCatalogView from '../vendorCatalog/VendorCatalogView';
import BulkEditStoreProductsView from './BulkEditStoreProductsView';
import StoreProductDetailsView from './StoreProductDetailsView';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';

const StoreProductsView = () => {
  const { state: authState } = useContext(AuthContext);
  const { state, fetchStoreCollections } = useContext(StoreContext);

  useEffect(() => {
    if (
      authState.pkEcomStore &&
      (!state.ecomStoreCollections.lastUpdated ||
        state.ecomStoreCollections.filter?.fkEcomStore !==
          authState.pkEcomStore)
    ) {
      fetchStoreCollections({ fkEcomStore: authState.pkEcomStore });
    }
  }, [authState.pkEcomStore]);

  return (
    <Routes>
      <Route element={<BulkEditStoreProductsView />} path="/bulk-edit/*" />
      <Route element={<VendorCatalogView />} path="/discover/*" />
      <Route
        element={<StoreProductDetailsView />}
        path="/:ecomStoreProductUuid"
      />
      <Route element={<StoreProductTable />} path="/" />
      <Route element={<Navigate replace to="/merchant/products" />} path="*" />
    </Routes>
  );
};

export default StoreProductsView;
